import { render } from "./MicrophoneIcon.vue?vue&type=template&id=0a4390ba"
import script from "./MicrophoneIcon.vue?vue&type=script&lang=js"
export * from "./MicrophoneIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/Components/ChatWidget/ChatIcons/MicrophoneIcon.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0a4390ba"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0a4390ba', __exports__)) {
    api.reload('0a4390ba', __exports__)
  }
  
  module.hot.accept("./MicrophoneIcon.vue?vue&type=template&id=0a4390ba", () => {
    api.rerender('0a4390ba', render)
  })

}


export default __exports__